module.exports = __webpack_public_path__ + "0d01e1fa009c0b206680c8e3e5d59e96.png";